<template>
  <div id="footer" class="footer-modern" :style="{ backgroundColor: websiteSettings?.footer_color || '#2d2d2d' }">
    <div class="footer-container">
      <!-- Left Section -->
      <div class="footer-left">
        <!-- Logo -->
        <div class="footer-logo">
          <img v-if="logo_src" :src="logo_src" alt="Company Logo" />
        </div>

        <!-- Contact Section -->
        <div v-if="company_phone_help_customer == 1 && ((company_phone1 != '') || (company_mobile1 != ''))" class="footer-contact-box">
          <div class="contact-box-inner">
            <div class="contact-icon">
              <a :href="`tel:${country_key}${company_phone1 || company_mobile1}`">
                <i class="fa fa-phone"></i>
              </a>
            </div>
            <div class="contact-details">
              <a class="contact-phone" v-if="company_phone1 != null" :href="`tel:${company_phone1}`" :data-countrycode="`${country_code}`">
                {{formatted_phone1 || company_phone1}}
              </a>
              <a class="contact-phone" v-else-if="(company_phone1 == null) && (company_mobile1 != null)" :href="`tel:${company_mobile1}`" :data-countrycode="`${country_code}`">
                {{formatted_mobile1 || company_mobile1}}
              </a>
              <div class="contact-hours" v-if="help_customer_available_hours">
                {{help_customer_available_hours}}
              </div>
            </div>
          </div>
        </div>

        <!-- Privacy & Terms -->
        <div class="footer-legal">
          <a v-if="privacyPolicy != null" :href="privacy_policy_link" target="_blank">{{ privacy_and_policy_translate }}</a>
          <span v-if="privacyPolicy != null && termsAndConditions != null"> | </span>
          <a v-if="termsAndConditions != null" :href="terms_conditions_link" target="_blank">{{terms_and_conditions_translate}}</a>
          <div class="footer-copyright">© {{company_name}}</div>
        </div>
      </div>

      <!-- Right Section -->
      <div class="footer-right">
        <!-- Navigation Links -->
        <div class="footer-nav">
          <a v-if="about_us_link || faqs_link || contact_us_link" :href="home_link">Home</a>
          <a v-if="about_us_link" :href="about_us_link">About Us</a>
          <a v-if="faqs_link" :href="faqs_link">Help Center / Faqs</a>
          <a v-if="contact_us_link" :href="contact_us_link">Contact Us</a>
        </div>

        <!-- App Buttons -->
        <div v-if="brandedApp.is_hidden == 0" class="footer-apps">
          <a v-if="brandedApp.ios_link != ''" :href="brandedApp.ios_link" target="_blank">
            <img src="/img/app_store.png" alt="Download on App Store"/>
          </a>
          <a v-if="brandedApp.android_link != ''" :href="brandedApp.android_link" target="_blank">
            <img src="/img/google_play.png" alt="Get it on Google Play"/>
          </a>
        </div>

        <!-- Social Icons -->
        <div class="footer-social">
          <a v-for="network in socialNetworks" :key="network.title" :href="network.url" target="_blank" :title="network.title">
            <i v-if="network.title.toLowerCase() === 'google'" class="fa fa-google-plus"></i>
            <i v-else :class="`fa fa-${network.title.toLowerCase()}`"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {getFooter} from "@/modules/CustomerPortal/api/footer";
import { parsePhoneNumberFromString, formatIncompletePhoneNumber } from 'libphonenumber-js';

export default {
  name: "CustomerPortalFooter",
  props: [
      "company_id",
      "privacy_policy_link",
      "terms_conditions_link",
      "logo_src",
      "home_link",
      "about_us_link",
      "faqs_link",
      "contact_us_link",
  ],
  data() {
    return {
      company_name : '',
      country_code : '',
      websiteSettings : '',
      brandedApp : '',
      socialNetworks : '',
      privacyPolicy : '',
      termsAndConditions : '',
      company_phone1 : '',
      company_mobile1 : '',
      company_phone_help_customer : 0,
      help_customer_available_hours : '',
      // call_us_translate : '',
      privacy_and_policy_translate : '',
      terms_and_conditions_translate : '',
      fa_network : 'fa fa-',
      country_key:'',
      formatted_phone1: '',
      formatted_mobile1: '',
    }
  },
  methods:{
    formatPhoneNumber(phoneNumber, countryCode) {
      if (!phoneNumber) return '';
      
      try {
        // Try to parse the phone number
        const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, countryCode);
        
        if (phoneNumberObj && phoneNumberObj.isValid()) {
          // Format as international format with spaces (e.g., +61 491 570 156)
          return phoneNumberObj.formatInternational();
        } else {
          // If parsing fails, try with country code
          if (countryCode) {
            const phoneNumberObjWithCountry = parsePhoneNumberFromString(phoneNumber, countryCode);
            if (phoneNumberObjWithCountry && phoneNumberObjWithCountry.isValid()) {
              return phoneNumberObjWithCountry.formatInternational();
            }
          }
          // If still fails, return original
          return phoneNumber;
        }
      } catch (e) {
        // If parsing fails, return original number
        return phoneNumber;
      }
    }
  },
  computed: {

  },
  mounted() {
      getFooter(this.company_id).then((response) => {
        console.log('id',this.company_id)
        if (parseInt(this.company_id) === 6008) {
          console.log('[6008] about_us_link:', this.about_us_link);
          console.log('[6008] faqs_link:', this.faqs_link);
          console.log('[6008] contact_us_link:', this.contact_us_link);
        }
        if (response.status == 200) {
          if (response.data.type == 'success') {
            this.company_name = response.data.company_name;
            this.country_code = response.data.country_code;
            this.websiteSettings = response.data.websiteSettings;
            this.brandedApp = response.data.brandedApp;
            this.socialNetworks = response.data.socialNetworks;
            this.privacyPolicy = response.data.privacyPolicy;
            this.termsAndConditions = response.data.termsAndConditions;
            this.company_phone1 = response.data.company_phone1;
            this.company_mobile1 = response.data.company_mobile1;
            this.company_phone_help_customer = response.data.company_phone_help_customer;
            this.help_customer_available_hours = response.data.help_customer_available_hours;
            // this.call_us_translate = response.data.call_us_translate;
            this.privacy_and_policy_translate = response.data.privacy_and_policy_translate;
            this.terms_and_conditions_translate = response.data.terms_and_conditions_translate;
            this.country_key = response.data.country_key;
            
            // Format phone numbers
            this.formatted_phone1 = this.formatPhoneNumber(this.company_phone1, this.country_code);
            this.formatted_mobile1 = this.formatPhoneNumber(this.company_mobile1, this.country_code);
          }
        }
      })
  }
}
</script>

<style scoped>
.footer-modern {
  padding: 40px 20px;
  color: #fff;
  position: relative;
  background: #000
}

.footer-container {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
  padding: 0 140px;
}

/* Left Section */
.footer-left {
  flex: 1;
  min-width: 280px;
}

.footer-logo {
  margin-bottom: 24px;
}

.footer-logo img {
  height: 50px;
  width: auto;
}

.footer-contact-box {
  background: linear-gradient(135deg, #9b59b6, #8e44ad);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  max-width: 320px;
}

.contact-box-inner {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contact-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
    background: linear-gradient(135deg, #00AEEF, #007bff);
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 174, 239, 0.3);

}

.contact-icon i {
  font-size: 24px;
  color: white;
}

.contact-details {
  flex: 1;
}

.contact-phone {
  color: #fff !important;
  font-size: 20px;
  font-weight: 700;
  text-decoration: none;
  display: block;
  margin-bottom: 2px;
  letter-spacing: 0.5px;
}

.contact-phone:hover {
  text-decoration: underline;
}

.contact-hours {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.3;
  margin-top: 2px;
}

.footer-legal {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  gap: 10px;
  padding-bottom: 20px;
}

.footer-legal a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-legal a:hover {
  color: #fff;
  text-decoration: underline;
}

.footer-copyright {
  margin-top: 8px;
}

/* Right Section */
.footer-right {
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.footer-nav {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-nav a {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: opacity 0.2s;
}

.footer-nav a:hover {
  opacity: 0.8;
}

.footer-apps {
  display: flex;
  gap: 12px;
  align-items: center;
}

.footer-apps img {
  height: 40px;
  width: auto;
  transition: transform 0.2s;
}

.footer-apps img:hover {
  transform: scale(1.05);
}

.footer-social {
  display: flex;
  gap: 12px;
}

.footer-social a {
  display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin: 3px;
    font-size: 20px;
    color: white;
    background-color: gray;
    border-radius: 5px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
}

.footer-social a:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.footer-social i {
  font-size: 16px;
}
.footer-copyright{margin: 0;}
/* Responsive */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0;
    padding: 0 20px;
    width: 100%; /* Ensure container takes full width */
    box-sizing: border-box; /* Prevent padding from adding to width */
  }

  .footer-left, .footer-right {
    display: contents;
  }

  /* Reorder elements */
  /* 1. Logo */
  .footer-logo {
    order: 1;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  /* 2. Contact Box */
  .footer-contact-box {
    order: 2;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto; /* Ensure centering */
    width: 100%;
    max-width: 320px;
    box-sizing: border-box; /* Important for padding */
  }

  /* 3. Navigation Links */
  .footer-nav {
    order: 3;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .footer-nav a {
    font-size: 16px;
  }

  /* 4. App Buttons */
  .footer-apps {
    order: 4;
    margin-bottom: 20px;
    justify-content: center;
    flex-wrap: wrap; /* Allow wrapping on very small screens */
    width: 100%;
  }

  /* 5. Social Icons */
  .footer-social {
    order: 5;
    margin-bottom: 20px;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 5px
  }

  /* 6. Legal/Copyright */
  .footer-legal {
         order: 6;
        margin-top: 20px;
        width: 100%;
        display: flex;
        gap: 10px;
        align-items: center;
        padding-bottom: 20px;
        justify-content: center;
  }
  
  .footer-legal span {
    display: none;
  }

}
</style>